import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConsoleSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75011 5.68933L11.0608 12L4.75011 18.3107L3.68945 17.25L8.93945 12L3.68945 6.74999L4.75011 5.68933ZM12.0001 16.5H20.0001V18H12.0001V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConsoleSimple;
